var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrainHumidityIndicator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12C16.9972 12 16.7475 12.015 16.5 12.0375V12C16.5 6.08625 14.283 1.5 12.375 1.5C10.467 1.5 8.25 6.08625 8.25 12V15.75H4.5V18C4.50139 19.193 4.97594 20.3368 5.81955 21.1804C6.66317 22.0241 7.80695 22.4986 9 22.5H11.25C13.4373 22.4976 15.5343 21.6277 17.081 20.081C18.6277 18.5343 19.4976 16.4373 19.5 14.25V12H17.25ZM9.75 12H11.25V10.5H9.80475C9.86766 9.49049 10.0093 8.48744 10.2285 7.5H12V6H10.65C11.2575 4.1955 12.0112 3.171 12.375 3.0105C12.87 3.2295 14.088 5.03775 14.6738 8.25H13.5V9.75H14.883C14.9606 10.4975 14.9997 11.2485 15 12V12.3195C13.086 12.8668 11.4328 14.0845 10.3425 15.75H9.75V12ZM9 21C8.20466 20.999 7.44217 20.6826 6.87978 20.1202C6.31738 19.5578 6.00099 18.7953 6 18V17.25H9.573C9.19529 18.2051 9.0009 19.2229 9 20.25V21ZM18 14.25C17.998 16.0396 17.2862 17.7553 16.0208 19.0208C14.7553 20.2862 13.0396 20.998 11.25 21H10.5V20.25C10.502 18.4604 11.2138 16.7447 12.4792 15.4792C13.7447 14.2138 15.4604 13.502 17.25 13.5H18V14.25Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrainHumidityIndicator);
export default __webpack_public_path__ + "static/media/grain-humidity-indicator.3bac1380.svg";
export { ForwardRef as ReactComponent };